import { accMul } from './math'
// 元转分
export default function yuanToFen (num) {
  if (num === undefined || num === null || num === '') {
    return num
  }
  return accMul(num, 100)
}
